angular.module('cfn').directive('cfnDatePicker', [
  'calendarService',
  function(calendarService) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        change: '&'
      },
      replace: true,
      template: '<div></div>',
      link: function(scope, element) {
        // $.datepicker.setDefaults(calendarService.getDatePickerConfig());
        element.datepicker({
          yearRange: '1900:2050'
        });
        scope.$watch(
          'model',
          function(newDate) {
            element.datepicker('setDate', new Date(newDate));
          },
          true
        );
        element.change(function() {
          ang.apply(scope, function() {
            var date = element.datepicker('getDate');
            if (date) {
              // if valid date
              scope.model = date.getTime();
            } else {
              scope.model = null;
            }
          });
          ang.apply(scope, function() {
            scope.change();
          });
        });
      }
    };
  }
]);
